import axiosConfig from "../../config/axios";

export const getAssistantsList = params => {
  return axiosConfig({
    url: `/assistants/`,
    method: "GET",
    params: {
      ordering: "user__first_name",
      is_active: true,
      ...params
    }
  });
};

export const getAdmins = () => {
  return axiosConfig({
    url: `/admins/`,
    method: "GET",
    params: {
      ordering: "user__first_name"
    }
  });
};

export const getAssistantDetails = profile_id => {
  return axiosConfig({
    url: `/assistants/${profile_id}/`,
    method: "GET"
  });
};

export const postAssitantInactiveDates = (profile_id, payload) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/inactive-dates/`,
    method: "post",
    data: payload
  });
};

export const patchAssitantInactiveDates = (profile_id, id, payload) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/inactive-dates/${id}/`,
    method: "patch",
    data: payload
  });
};

export const getAdminsDetails = profile_id => {
  return axiosConfig({
    url: `/admins/${profile_id}/`,
    method: "GET"
  });
};

export const getAssistantsAddress = profile_id => {
  return axiosConfig({
    url: `/assistants/${profile_id}/address/`,
    method: "GET"
  });
};

export const patchAssistantProfile = (assistantID, profileID, payload) => {
  return axiosConfig({
    url: `/assistants/${assistantID}/profile/${profileID}/`,
    method: "patch",
    data: payload
  });
};

export const addWeeklyNotes = (profile_id, payload) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/meetingnotes/`,
    method: "POST",
    data: payload
  });
};

export const patchWeeklyNotes = (profile_id, payload, notes_id) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/meetingnotes/${notes_id}/`,
    method: "PATCH",
    data: payload
  });
};

export const deleteWeeklyNotes = (profile_id, notes_id) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/meetingnotes/${notes_id}/`,
    method: "DELETE",
  });
};

export const getNotesListAssistant = (profile_id, only_customers, limit, offset) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/meetingnotes/`,
    method: "GET",
    params: {
      only_customers: only_customers,
      limit: limit,
      offset: offset
    }
  });
};

export const getNoteDetails = (profile_id, note_id) => {
  return axiosConfig({
    url: `/assistants/${profile_id}/meetingnotes/${note_id}`,
    method: "GET"
  });
};

export const getNotesForAllAssistants = () => {
  return axiosConfig({
    url: `/meetingnotes/`,
    method: "GET"
  });
};

export const getAssistantsTasks = (profileID, status = "", customer = "") => {
  if (status === null) {
    status = "";
  }
  if (customer === null) {
    customer = "";
  }
  return axiosConfig({
    url: `/assistants/${profileID}/tasks/?status=${status}&created_for=${customer}`,
    method: "GET"
  });
};

export const handOverTask = payload => {
  return axiosConfig({
    url: `/task-handover-requests/`,
    method: "post",
    data: payload
  });
};

export const updateHandOverTask = (requestID, payload) => {
  return axiosConfig({
    url: `/task-handover-requests/${requestID}/`,
    method: "patch",
    data: payload
  });
};

export const deleteHandoverRequest = requestID => {
  return axiosConfig({
    url: `/task-handover-requests/${requestID}/`,
    method: "delete"
  });
};
export const getHandoverTask = params => {
  return axiosConfig({
    url: `/task-handover-requests/`,
    method: "GET",
    params: {
      ...params
    }
  });
};

export const deleteAssistant = id => {
  return axiosConfig({
    url: `/assistants/${id}/`,
    method: "DELETE"
  });
};
